module.exports = __webpack_public_path__ + "pc/img/puzzle_bg_02.c6426a23.png";